import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";

// Hide on routes where a booking nudge is redundant or distracting.
const HIDDEN_ROUTES = ["/booking", "/admin", "/recommend"];

export const StickyCTA = () => {
    const location = useLocation();
    const [visible, setVisible] = useState(false);

    useEffect(() => {
        const onScroll = () => setVisible(window.scrollY > 480);
        onScroll();
        window.addEventListener("scroll", onScroll, { passive: true });
        return () => window.removeEventListener("scroll", onScroll);
    }, []);

    if (HIDDEN_ROUTES.some((p) => location.pathname.startsWith(p))) return null;

    return (
        <Link
            to="/booking"
            data-testid="sticky-cta"
            aria-label="Book a Consultation"
            className={`fixed bottom-6 left-6 z-40 hidden sm:inline-flex items-center gap-2 px-5 py-3 text-sm tracking-wide bg-brand-navy text-brand-stone border border-brand-champagne/40 shadow-[0_10px_30px_-12px_rgba(11,19,43,0.55)] hover:bg-brand-hover transition-all duration-300 ${
                visible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-3 pointer-events-none"
            }`}
        >
            Book a Consultation
            <ArrowUpRight size={14} />
        </Link>
    );
};

export const StickyCTAMobile = () => {
    const location = useLocation();
    if (HIDDEN_ROUTES.some((p) => location.pathname.startsWith(p))) return null;

    return (
        <div
            data-testid="sticky-cta-mobile"
            className="sm:hidden fixed bottom-4 inset-x-4 z-40"
        >
            <Link
                to="/booking"
                aria-label="Book a Consultation"
                className="flex items-center justify-center gap-2 px-5 py-3.5 text-sm tracking-wide bg-brand-navy text-brand-stone border border-brand-champagne/40 shadow-[0_10px_30px_-12px_rgba(11,19,43,0.55)]"
            >
                Book a Consultation
                <ArrowUpRight size={14} />
            </Link>
        </div>
    );
};
